export const PricingData = [
    [
        {title: 'Basic' ,name: 'First Service', price: 10},
        {title: 'Standard' ,name: 'Second Service', price: 15},
        {title: 'Premium' ,name: 'Third Service', price: 30},
    ],
    [
        {title: 'Basic' ,name: 'Second Service', price: 39},
        {title: 'Standard' ,name: 'Second Service', price: 79},
        {title: 'Premium' ,name: 'Second Service', price: 99},
    ],
    [
        {title: 'Basic' ,name: 'Third Service', price: 36},
        {title: 'Standard' ,name: 'Third Service', price: 56},
        {title: 'Premium' ,name: 'Third Service', price: 86},
    ]
]